iScreenWizard.factory('Testotheek', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('testotheek', params).then(function (response) {
                var testotheken = response.data;
                resolve(testotheken);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testotheek/'+id).then(function (response) {
                var testotheek = response.data;
                resolve(testotheek);
            }, reject);
        });
    };

    return data;
});